import { create } from 'zustand';
import { AxiosRequestConfig } from 'axios';

type OtpStep = 'idle' | 'sending' | 'otpInput' | 'verifying' | 'success';

interface NoonLoginState {
  visible: boolean;
  message: string;
  retryConfig: AxiosRequestConfig | null;
  step: OtpStep;
  maskedEmail: string;
  loading: boolean;

  show: (message: string, retryConfig: AxiosRequestConfig) => void;
  hide: () => void;
  setStep: (step: OtpStep) => void;
  setMaskedEmail: (email: string) => void;
  setLoading: (loading: boolean) => void;
}

export const useNoonLoginStore = create<NoonLoginState>((set) => ({
  visible: false,
  message: '',
  retryConfig: null,
  step: 'idle',
  maskedEmail: '',
  loading: false,

  show: (message, retryConfig) =>
    set({ visible: true, message, retryConfig, step: 'idle', maskedEmail: '', loading: false }),

  hide: () =>
    set({ visible: false, message: '', retryConfig: null, step: 'idle', maskedEmail: '', loading: false }),

  setStep: (step) => set({ step }),
  setMaskedEmail: (email) => set({ maskedEmail: email }),
  setLoading: (loading) => set({ loading }),
}));
